// Microsoft Clarity project IDs, keyed by host (see ApiEndpoints.js).
const Projects = {
	'localhost:8080':'yfl77tec8k',
	'dev-fleet.pocketbox.co':'yfl77tec8k',
	'fleet.pocketbox.co':'yflaf8kil3',
}
const ProjectId = Projects[window.location.host] || null;

// Clarity's own user ID is per-browser and per-device, so one person shows up as
// several "users". The Identify API stitches those together under our own ID.
// See https://learn.microsoft.com/en-us/clarity/setup-and-installation/identify-api
const SessionKey = 'ClaritySessionId';

// Clarity's Consent Mode is on by default for UK/EEA/CH visitors, and since
// 31 Oct 2025 Clarity enforces it. Without a consent signal it sets no _clck /
// _clsk cookies and assigns a NEW user + session ID per page view, so one person
// reloading a page counts as several users. We persist the decision per device
// and replay it on every load. See consent-mode + clarity-consent-api-v2 docs.
const ConsentKey = 'ClarityConsent';

// Replays the stored consent decision. Sends nothing when no decision has been
// made yet, which leaves Clarity in its default cookieless no-consent mode.
export function applyClarityConsent() {
	if (!ProjectId || !window.clarity) return;
	var Granted = localStorage.getItem(ConsentKey);
	if (Granted === null) return;
	window.clarity('consentv2', {
		ad_Storage: 'denied',
		analytics_Storage: Granted === 'true' ? 'granted' : 'denied',
	});
}

// Call with true once the user has agreed to analytics cookies, false if they
// decline or withdraw. Passing false makes Clarity drop any cookies it has set
// and restart in no-consent mode.
export function setClarityConsent(Granted) {
	localStorage.setItem(ConsentKey, Granted ? 'true' : 'false');
	applyClarityConsent();
}

// Whether a decision has been recorded on this device, so a prompt can be shown
// only to people who haven't answered yet.
export function hasClarityConsentDecision() {
	return localStorage.getItem(ConsentKey) !== null;
}

// Official Clarity snippet, with the project ID resolved at runtime.
export function initClarity() {
	if (!ProjectId) return;
	(function(c,l,a,r,i,t,y){
		c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
		t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
		y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
	})(window, document, "clarity", "script", ProjectId);
	// The snippet installs a synchronous command queue, so this is safe to call
	// before the tag itself has finished downloading.
	applyClarityConsent();
}

// One ID per browser tab session, so recordings group into visits rather than
// one endless session per user.
function ClaritySessionId() {
	var Id = sessionStorage.getItem(SessionKey);
	if (!Id) {
		Id = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
		sessionStorage.setItem(SessionKey, Id);
	}
	return Id;
}

// The label shown against a session on the Clarity dashboard. Company ID is
// included so sessions can be grouped by account without naming anyone.
function ClarityFriendlyName(User) {
	var CompanyId = null;
	try {
		var Company = JSON.parse(localStorage.getItem('Company'));
		CompanyId = Company && Company.id;
	} catch (e) {
		CompanyId = null;
	}
	return (CompanyId ? 'C' + CompanyId + '-' : '') + 'U' + User.id;
}

// Clarity recommends calling identify on every page, so this is safe to call
// after login and on each route change. No-op until the user is logged in.
export function identifyClarity(PageId) {
	if (!ProjectId || !window.clarity) return;
	var User = null;
	try {
		User = JSON.parse(localStorage.getItem('User'));
	} catch (e) {
		return;
	}
	if (!User || !User.id) return;
	// custom-id is hashed client side before it leaves the browser, so it never
	// shows on the dashboard; friendly-name is what's displayed against a session
	// and is sent in the clear. Keep it to opaque IDs, never the person's name.
	window.clarity('identify', 'user-' + User.id, ClaritySessionId(), PageId || window.location.pathname, ClarityFriendlyName(User));
}

// Called on logout so the next person to log in on this browser doesn't inherit
// the previous user's Clarity session ID.
export function resetClaritySession() {
	sessionStorage.removeItem(SessionKey);
}

export default ProjectId;
